<template>
  <b-form id="round-info" @submit.prevent="onSubmitForm">
    <b-row class="round-info">
      <b-col cols="12">
        <b-card no-body class="mb-1 pb-4 container-card">
          <div class="row px-5">
            <div class="col-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6 mt-4">
                      <b-form-group
                        :label="'Description'"
                        label-for="round-description"
                        label-class="font-medium-5 required"
                      >
                        <b-form-input
                          id="round-description"
                          v-model="roundInfoData.description"
                          required
                        />
                      </b-form-group>
                      <div class="mb-1">
                        <label
                          for="valid-from-date"
                          class="font-medium-5 required"
                        >
                          Announcement Date
                        </label>
                        <div class="d-flex">
                          <div
                            class="
                              col
                              p-0 p-relative
                              mr-2
                            "
                          >
                            <calendar-picker-icon
                              class="icon-calendar bypass"
                              :class="
                                validFrom.date ? 'date-selected-icon' : null
                              "
                            />
                            <flat-pickr
                              :id="'valid-from-date'"
                              v-model="validFrom.date"
                              class="form-control  bg-date"
                              :class="validFrom.date ? 'date-selected' : null"
                              :config="flatpickrDateConfig"
                              placeholder="Start Date"
                              autocomplete="off"
                              @on-open="onOpenValidFromDatePicker"
                              @on-change="onSelectValidFromDate"
                              required
                            />
                          </div>
                          <div class="col p-0 p-relative">
                            <clock-picker-icon
                              class="icon-calendar date-picker-icon bypass"
                              :class="
                                validFrom.time ? 'date-selected-icon' : null
                              "
                            />
                            <flat-pickr
                              id="valid-from-time"
                              v-model="validFrom.time"
                              class="form-control  bg-date"
                              :class="validFrom.time ? 'date-selected' : null"
                              :config="flatpickrTimeConfig"
                              :placeholder="'HH : mm'"
                              autocomplete="off"
                              @on-open="onOpenValidFromTimePicker"
                              @on-change="onSelectValidFromTimePicker"
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div class="mt-2">
                        <span class="font-medium-5">{{ "Status" }} </span>
                        <b-form-checkbox
                          v-model="roundInfoData.status"
                          class="custom-control-success custom-toggle mt-1"
                          name="check-button"
                          switch
                        >
                          <span class="switch-icon-left toggle-text">{{
                            "Active"
                          }}</span>
                          <span class="switch-icon-right toggle-text">{{
                            "Inactive"
                          }}</span>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
        <div class="privilege-btn-wrp mt-4 mb-2">
          <div class="d-flex justify-content-center">
            <cancel-button
              class="mr-2"
              @click.native="
                $router.push(`/lucky-winner/campaign/${campaignId}/round/list`)
              "
            />
            <save-button type="submit" class="ml-1"/>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue"
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue"
import flatPickr from "vue-flatpickr-component"
import useRoundInfo from "./hooks/useRoundInfo"

export default {
  components: { CalendarPickerIcon, ClockPickerIcon, flatPickr },

  setup() {
    const {
      campaignId,
      roundInfoData,
      validFrom,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
    } = useRoundInfo()

    return {
      campaignId,
      roundInfoData,
      CalendarPickerIcon,
      ClockPickerIcon,
      flatPickr,
      validFrom,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      onSubmitForm,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
</style>
